import BackgroundLayer from "@/components/BackgroundLayer";
import RadioGroup from "@/components/RadioGroup";
import { ListenButton } from "@/components/AudioControls";

const THRESHOLD_OPTIONS = [
  { value: "10", label: "10%: I'd want to have a review at 10%." },
  { value: "20", label: "20%: That's when I'd take a serious look." },
  { value: "30", label: "30%: I could hold through 30% — it's temporary." },
  { value: "40", label: "40%+: I don't react to drops." },
];

export default function SetScenario({ sessionData, updateSession, onNext, onBack, stageIndex }) {
  return (
    <div className="page-wrapper" data-testid="set-scenario-page">
      <BackgroundLayer image="/images/page2_bg.jpg" />
      <div className="content-layer" style={{ minHeight: "100vh", minHeight: "100dvh" }}>
        <div className="page-content" style={{ paddingTop: 60, paddingBottom: 80 }}>
          <div className="section-label animate-in" style={{ marginBottom: 12 }}>01: Set the Scenario</div>
          <div className="animate-in animate-in-d1" style={{ marginBottom: 20 }}>
            <ListenButton stageIndex={stageIndex} />
          </div>

          <div className="section-text-block">
            <p className="body-text animate-in animate-in-d1">
              It's early 2008.
            </p>
            <p className="body-text animate-in animate-in-d2">
              March happened fast — faster than most people expected — and the word "recession" has moved from the opinion pages to the front page. Those headlines are not quiet.
            </p>
            <p className="body-text animate-in animate-in-d3">
              You know you had a good run through the years. Your portfolio reflects it.
            </p>
            <p className="body-text animate-in animate-in-d4">
              You read the headlines. You're not panicking. You're paying attention.
            </p>
            <p className="standout-line animate-in animate-in-d5" style={{ marginTop: 28, marginBottom: 8 }}>
              Before anything — where's your line?
            </p>
            <p className="body-text animate-in animate-in-d5">
              At what point would you seriously reconsider your current allocation?
            </p>
            <p className="standout-line animate-in animate-in-d6" style={{ marginBottom: 4 }}>
              Set your threshold.
            </p>
          </div>

          <div className="animate-in animate-in-d7">
            <RadioGroup
              name="threshold"
              options={THRESHOLD_OPTIONS}
              selected={sessionData.threshold}
              onSelect={(v) => updateSession("threshold", v)}
            />
          </div>

          <div className="nav-buttons animate-in animate-in-d8">
            <button className="nav-back" onClick={onBack} data-testid="back-btn">Back</button>
            <button
              className="cta-pill"
              onClick={onNext}
              disabled={!sessionData.threshold}
              data-testid="next-btn"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
